module.exports = __webpack_public_path__ + "img/img-6.1b941f63.png";